"use client";

import React, { useEffect, useState } from "react";
// import Image from 'next/image';
import * as Icon from "@phosphor-icons/react/dist/ssr";
import { useLocale, useTranslations } from "next-intl";
import Drawer from "@/components/Drawer";
import CartContent from "@/components/Product/ShoppingCart/cartContent";
import NavUser from "@/components/User/nav-user";
import { usePathname } from "next/navigation";
import FlagIcon from "../../Flag/index";
import { SITE_LOCALES } from "@/lib/constant";
import { type TLocale } from "@/lib/@types/locale";
import { defaultLocale } from "@/config";
import { Link } from "@/navigation";
import { LinkedinLogo, TiktokLogo } from "@phosphor-icons/react";
import { SocialList } from "@/components/Social/FollowUs";

import { useUserStore } from "@/store/user.store";
import { CartDrawerOpen } from "@/lib/store/CartDrawerOpen";
import { contactInfo } from "@/lib/contacts";

interface Props {
	props: string;
	slogan?: string;
}

const TopNavOne: React.FC<Props> = ({ props, slogan }) => {
	const t = useTranslations();
	const { userInfo } = useUserStore();
	let { open, setOpen } = CartDrawerOpen();
	// const [isOpenCurrence, setIsOpenCurrence] = useState(false);
	// const [language, setLanguage] = useState("English");
	// const [currence, setCurrence] = useState("USD");
	// const {  replace, asPath } = useRouter();
	const [user, setUser] = useState<any>();
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		setUser(userInfo);
	}, [userInfo]);

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 40) {
				setScrolled(true);
			} else {
				setScrolled(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	// 语言列表
	return (
		<>
			<div
				className={`top-nav hidden h-[40px] transition-all duration-300 max-md:bg-black  ${
					scrolled ? "!bg-black" : "!border-0 bg-transparent !shadow-none"
				} ${props} `}
			>
				<Drawer
					width={"450px"}
					className="cursor-auto !overflow-hidden max-md:!w-10/12"
					visible={open}
					direction="right"
					onClose={() => setOpen(false)}
					title={t("shop.0b1dcf5c5c3d9b4fe53b771d965840f7159e")}
				>
					<div className="px-2 ">
						{/* @ts-ignore */}
						<CartContent layout="col" />
					</div>
				</Drawer>
				<div className="container mx-auto h-full">
					<div className="top-nav-main font-poppins mx-[200px] flex h-full justify-between gap-8 max-lg:mx-[0px] max-lg:justify-center">
						{/* <div className="left-content flex items-center gap-5 ">
							<div
								className="choose-type choose-language flex items-center gap-1.5"
								onClick={() => {
									setIsOpenLanguage(!isOpenLanguage);
									// setIsOpenCurrence(false);
								}}
							>
								<div className="select relative flex">
									<p className="selected caption2 flex gap-x-1 text-white">
										<FlagIcon flag={getFlag(locale)} />
										{currentLocales.find((item) => item.code === locale)?.nativeName || defaultLocale}{" "}
									</p>
									<ul className={`list-option bg-white ${isOpenLanguage ? "open" : ""} z-90`}>
										{currentLocales.map((item, index) => (
											<Link key={index} href={currentSlug} locale={item.code} className="!hover:bg-[#eeeeee]">
												<li className="caption2 m-1 flex items-center justify-start gap-x-1 rounded-sm border p-2 ">
													<FlagIcon flag={getFlag(item.code)} />
													<span className="inline-block text-nowrap">{item.nativeName}</span>
												</li>
											</Link>
										))}
									</ul>
								</div>
								<Icon.CaretDown size={12} color="#fff" />
							</div>
						</div> */}
						<div className=" flex items-center max-md:ml-0 max-md:hidden ">
							<p className={`${scrolled ? "text-white" : "text-black"}`}>{contactInfo.email}</p>
						</div>
						<div
							className={`flex items-center text-center uppercase ${
								scrolled ? "text-white" : "text-black"
							} max-md:hidden`}
						>
							<span className="text-xs"> {t("home.slogan")}</span>
							{/* <Link href="/contact-us" className="ml-2 text-xs font-bold text-white">
								{t("menu.contactUs")}
							</Link> */}
						</div>

						<div className="right-content  flex items-center gap-5 max-md:ml-5  max-md:mr-0">
							{/* <SocialList></SocialList> */}
							<div className="c-flex cursor-pointer  px-2 ">
								<NavUser>
									<div className="c-flex h-[42px]  rounded-full ">
										<div
											className={`s-flex gap-x-2 max-md:text-white ${scrolled ? "text-white" : "text-black"}`}
										>
											<Icon.User size={24} weight="regular" />
											{/* <p className="">{user ? user.username : t("home.My Account")}</p> */}
											{/* <img className="w-[2rem] h-[2rem]" src="/image/home/icon/user.png" alt="user" /> */}
										</div>
									</div>
								</NavUser>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default TopNavOne;
